import { CellError } from "./CellError"
import { CellProps } from "components/TreeState"
import { TextCell } from "./TextCell"
import { css } from "@emotion/css"
import { get } from "lodash"
import { getCellPerType } from "../utils"
import { useCellDialog } from "../useCellDialog"
import { useDGPreference } from "../useDGPreference"
import { useSnapshot } from "valtio"
import { useTableSource } from "routes/Base/Plans/Details/TableStateProvider"

export function DigitalCalculatorCell(props: CellProps) {
  const { rowId: id, dataKey, columnId, disabled, editType, semantic } = props
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const readError = useSnapshot(tableSource.errors)
  const { value: dgEnabled } = useDGPreference()
  const { onChange } = useCellDialog()

  const onOpenDigitalCalculator = () => {
    onChange({ type: "digital_calculator", fieldInfo: { rowId: id, dataKey } })
  }

  const values = readFrom[id] || {}
  const { type } = values
  const isPackage = type === "package"
  const isLineItem = type === "line_item"
  const readonly = !isPackage && !isLineItem
  const error = get(readError, `${id}.${columnId}`)

  const calculatorDisabled = !dgEnabled || disabled || !isLineItem
  const isCellDisabled = readonly || disabled || (dgEnabled && isLineItem)

  const Renderer = editType
    ? getCellPerType({ type: editType, semantic })
    : TextCell

  return (
    <>
      <div
        className={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          justify-content: center;
        `}
        onPointerDown={() => !calculatorDisabled && onOpenDigitalCalculator()}
      >
        <Renderer {...props} disabled={isCellDisabled} />
      </div>
      {!!error ? <CellError error={error} /> : null}
    </>
  )
}
